export function k2IdHistoryAppendItem (k2IdInputHistoryItems, item) {
  if (!k2IdInputHistoryItems.includes(item)) {
    k2IdInputHistoryItems.push(item)
  }

  return k2IdInputHistoryItems.slice(-6)
}

export function isK2IdValid (k2Id) {
  const regex = /^\d{5,6}$/

  return regex.test(k2Id)
}
